import React from "react";
import { shallowEqual, useSelector } from "react-redux";
// components
import RMDRImage from "@/components/RMDRImage";
import RMDRLink from "@/components/RMDRLink";
// utilities
import { outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
// type
import { TMainPageLayoutV3 } from "../type";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import ESizeType from "@/cms/enums/ESizeType";


const MNPG048 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG048.rendered: ", props);

    const webApplicationLanguageISOCode = useSelector((state:any) => state.CoreStore.languageCode?.payload, shallowEqual);

    if ( !props.template ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.template.languageVersions);

    return (
        <div className="header-left">
            <div className="logo">
                <RMDRLink
                    title={languageVersion?.name}
                    hasNavigationDestination={props.template.hasDestinationNavigation}
                    navigationURL={`/${webApplicationLanguageISOCode}`}
                    redirectType={props.template?.redirectType}
                    className="header-logo"
                    isShowAlways={true}
                    variant="div"
                >
                    <RMDRImage
                        resourceType={EResourceType.LOGO_DEFAULT} 
                        resources={props.template?.resources} 
                        sizeType={ESizeType.X06}
                        alt={languageVersion?.name} 
                        title={languageVersion?.name}
                    />
                </RMDRLink>
            </div>
        </div>
    )
}

const Component = React.memo(MNPG048, ( prevProps:TMainPageLayoutV3, nextProps:TMainPageLayoutV3 ) => {
    return true;
});

export default Component;
